<template>
  <div class="position-absolute d-flex justify-content-center align-items-center task-error" v-if="errorVisible">
    <div class="task-error__window" p="1">
      <div class="task-error__window__message text-danger">
        {{ errorMessage }}
      </div>
      <div mt="1" class="d-flex justify-content-center">
        <button class="button button-danger" @click="errorOkHandler()">OK</button>
      </div>
    </div>
  </div>
</template>
<script>
import { ERROR_TYPES } from './tasksConsts';
  export default{
    data: function(){
      return {
        errorVisible: false,
      }
    },
    props: {
      error: {
        type: Object,
        default: () => ({})
      }
    },
    computed: {
      errorMessage: function(){
        switch(this.error.errorType){
          case ERROR_TYPES.createError:
            return this.$i18n.t(`errors.createError`)
          case ERROR_TYPES.updateError:
            return this.$i18n.t(`errors.updateError`)
          case ERROR_TYPES.timesUpError:
            return this.$i18n.t('errors.timesUpError')
          case ERROR_TYPES.deleteError:
            return this.$i18n.t('errors.deleteError')
          case ERROR_TYPES.newTagError:
            return this.$i18n.t('errors.newTagError')
          case ERROR_TYPES.searchTagError:
            return this.$i18n.t('errors.searchTagError')
          case ERROR_TYPES.selectDateError:
            return this.$i18n.t('errors.selectDateError')
          case ERROR_TYPES.archiveError:
            return this.$i18n.t('errors.archiveError')
          case ERROR_TYPES.unarchiveError:
            return this.$i18n.t('errors.unarchiveError')
        }
      }
    },
    i18n: {
      messages: {
        "pt-BR": {
          errors: {
            createError: 'Erro ao criar a nova tarefa',
            updateError: 'Erro ao atualizar a tarefa',
            playError: 'Erro ao iniciar a tarefa',
            timesUpError: 'Erro ao finalizar a tarefa',
            deleteError: 'Erro ao remover a tarefa',
            newTagError: 'Erro ao adicionar uma nova tag',
            searchTagError: 'Erro ao pesquisar tags',
            selectDateError: 'Erro ao selecionar a data',
            archiveError: 'Erro ao arquivar a tarefa',
            unarchiveError: 'Erro ao desarquivar a tarefa',
            addTagError: 'Erro ao adicionar esta etiqueta',
            removeTagError: 'Erro ao remover esta etiqueta'
          }
        },
        en: {
          errors: {
            createError: 'An error ocurred when creating a new task',
            updateError: 'An error ocurred when updating this task',
            playError: 'An error ocurred when playing this task',
            timesUpError: 'An error ocurred when finishing the task',
            deleteError: 'An error ocurred when deleting this task',
            newTagError: 'An error ocurred when creating a new tag',
            searchTagError: 'An error ocurred when searching tags',
            selectDateError: 'An error ocurred when selecting the date',
            archiveError: 'An error ocurred when archiving this task',
            unarchiveError: 'An error ocurred when unarchiving this task',
            addTagError: 'An error ocurred when adding this tag',
            removeTagError: 'An error ocurred when removind this tag'
          }
        }
      }
    },
    methods: {
      errorOkHandler(){
        this.errorVisible=false;
      }
    },
    watch: {
      error: function(newValue, oldValue){
        this.errorVisible = newValue.hasError;
      }
    },
  }
</script>
